import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function RelatedProducts({ products }) {
  return (
    <div>
      <div className="container">
        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-6 g-3 pb-3">
          {products.map((p) => (
            <div className="col" key={p._id}>
              <div className="card shadow-sm relateditems">
                <Link
                  to={{ pathname: `/products/${p._id}`, state: { products } }}
                >
                  <img
                    src={p.image}
                    className="card-img-top mx-auto d-block"
                    alt={p.name}
                  />
                </Link>

                <div className="card-body ">
                  <Link
                    to={{ pathname: `/products/${p._id}`, state: { products } }}
                    className="text-decoration-none product_title text-dark relateditems_name"
                  >
                    {p.name}
                  </Link>
                  <div className="d-flex justify-content-between align-items-center">
                    <small className=" text-secondary pt-1">{p.brand}</small>
                    <small className="">
                      <strong>${p.price}</strong>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RelatedProducts;
